import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import SidebarContext from 'src/utils/context/SidebarContext';
import Svg from 'src/components/Svg';
import NotificationsMenu from 'src/components/NotificationsMenu';
import LanguageSelect from 'src/components/LanguageSelect';
import UserMenu from 'src/components/UserMenu';
import authToken from 'src/utils/auth';
import { jwtDecode } from 'jwt-decode';
import Styled from './TopBarMenu.styles';

const TopBarMenu = (props) => {
  let { expanded } = useContext(SidebarContext);
  expanded = expanded ? true : undefined;
  const [platformsAccess, setPlatformsAccess] = useState({
    eiqanalyze: false,
    eiqlearning: false,
    eiqsite: false
  });

  useEffect(() => {
    const token = authToken()?.accessToken;
    if(token){
      const decodedToken = jwtDecode(token);
      const appAccessArray = decodedToken['http://app_access'];
      // ['analyse', 'assess', 'learn', 'site']
      setPlatformsAccess({
        eiqanalyze: appAccessArray?.includes('analyse'),
        eiqsite: appAccessArray?.includes('site'),
        eiqlearning: appAccessArray?.includes('learn'),
      });
    }
  }, []);

  const navigateToEiqAnalyze = () => {
    if (!SSO_HOST || !EIQ_ANALYZE_HOST || !platformsAccess.eiqanalyze) {
      return;
    }
    window.location.replace(`https://${SSO_HOST}/go?target_url=${EIQ_ANALYZE_HOST}&requester=eiqassess&destination=eiqanalyze`);
  };

  const navigateToEiqLearn = () => {
    if (!SSO_HOST || !EIQ_LEARN_HOST || !platformsAccess.eiqlearning) {
      return;
    }
    window.location.replace(`https://${SSO_HOST}/go?target_url=${EIQ_LEARN_HOST}&requester=eiqassess&destination=eiqlearning`);
  };

  const setRedirectAppQuery = (value) => {
    
      const auth0ClientIds = {
        analyse: EIQ_ANALYSE_AUTH0_CLIENT_ID,
        site: EIQ_SITE_AUTH0_CLIENT_ID,
        learn: EIQ_LEARN_AUTH0_CLIENT_ID,
      };

      const auth0RedirectUris = {
        analyse: EIQ_ANALYSE_AUTH0_REDIRECT_URI,
        site: EIQ_SITE_AUTH0_REDIRECT_URI,
        learn: EIQ_LEARN_AUTH0_REDIRECT_URI,
      };
      if(value === 'learn' && !EIQ_LEARN_USING_NEW_SSO){
        navigateToEiqLearn();        
      }else{
        window.location.replace(`https://${AUTH0_DOMAIN}/authorize?prompt=none&response_type=code&client_id=${auth0ClientIds[value]}&redirect_uri=${auth0RedirectUris[value]}&scope=email`);
      }
  }

  return (
    <Styled.TopBarMenu expanded={expanded} {...props}>
      <div>{/* dummy div */}</div>
      <Styled.PlatformGroup expanded={expanded}>
        {platformsAccess.eiqanalyze &&
          <Styled.PlatformButton left-btn onClick={() => setRedirectAppQuery('analyse')} expanded={expanded}>
            <Svg name="eiq-analyze-nav-btn-sm"/>
          </Styled.PlatformButton>}
        {platformsAccess.eiqsite &&
          <Styled.PlatformButton onClick={() => setRedirectAppQuery('site')} expanded={expanded}>
            <Svg name="eiq-site-nav-btn-sm"/>
          </Styled.PlatformButton>}
        {platformsAccess.eiqlearning &&
          <Styled.PlatformButton onClick={() => setRedirectAppQuery('learn')} right-btn expanded={expanded}>
            <Svg name="eiq-learn-nav-btn-sm"/>
          </Styled.PlatformButton>}
      </Styled.PlatformGroup>
      <Styled.MenuContainer expanded={expanded}>
        <LanguageSelect expanded={expanded} />
        <NotificationsMenu expanded={expanded} />
        <UserMenu />
      </Styled.MenuContainer>
    </Styled.TopBarMenu>
  );
};

TopBarMenu.props = {
  horizontal: PropTypes.bool,
};

TopBarMenu.defaultProps = {
  horizontal: true,
};

export default React.memo(TopBarMenu);
